import { useTranslation } from 'react-i18next';

type GroupAction = 'view' | 'edit' | 'delete';

interface GroupsTableActionMenuProps {
  groupId: string;
  position: { top: number; right: number };
  isCurrentUserAdmin: boolean;
  onAction: (groupId: string, action: GroupAction) => void;
  onClose: () => void;
}

export const GroupsTableActionMenu = ({
  groupId,
  position,
  isCurrentUserAdmin,
  onAction,
  onClose,
}: GroupsTableActionMenuProps) => {
  const { t } = useTranslation();

  const handleAction = (action: GroupAction) => {
    onAction(groupId, action);
    onClose();
  };

  return (
    <div
      className="action-menu fixed z-50 w-48 bg-white rounded-md shadow-lg border border-gray-200"
      style={{ top: `${position.top}px`, right: `${position.right}px` }}
    >
      <div className="py-1">
        <button
          onClick={() => handleAction('view')}
          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
        >
          {t('admin.groups.actions.view')}
        </button>
        {isCurrentUserAdmin && (
          <>
            <button
              onClick={() => handleAction('edit')}
              className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              {t('admin.groups.actions.edit')}
            </button>
            <button
              onClick={() => handleAction('delete')}
              className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
            >
              {t('admin.groups.actions.delete')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
